/**
 * KAN-826: block "Данные из базы" of the client card: own fields of the
 * contact from list imports (profile_data), read-only. Hidden when empty.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toExtraFieldItems } from '@/lib/extraFields';
import { ExtraFieldsList } from './ExtraFieldsList';

export function ClientProfileDataCard({ data }: { data?: Record<string, unknown> | null }) {
  const items = toExtraFieldItems(data);
  if (items.length === 0) return null;
  return (
    <Card data-testid="client-profile-data">
      <CardHeader>
        <CardTitle className="text-base">Данные из базы</CardTitle>
      </CardHeader>
      <CardContent>
        <ExtraFieldsList items={items} />
      </CardContent>
    </Card>
  );
}
